import styled, { css, keyframes } from 'styled-components';
import { SpinnerProps } from './Spinner';

const spinLoader = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

export const Element = styled.div<SpinnerProps>`
  ${({ theme, ...props }) => {
    return css`
      display: flex;
      flex-direction: column;
      gap: 1rem;
      justify-content: center;
      align-items: center;
      flex-grow: 1;
    `;
  }};
`;

export const Loader = styled.div`
  ${({ theme, ...props }) => {
    return css`
      width: 3rem;
      height: 3rem;
      border: 5px solid ${theme.color.neutral_500};
      border-bottom-color: transparent;
      border-radius: 50%;
      display: inline-block;
      box-sizing: border-box;
      animation: ${spinLoader} 1s linear infinite;
    `;
  }};
`;
